'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * RF Server API
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * this is the API for the RF server
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The version of the OpenAPI document: 1.0.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Contact: bryan@dau.it
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ApiClient = require('../ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _AuthorizationServer = require('../model/AuthorizationServer');

var _AuthorizationServer2 = _interopRequireDefault(_AuthorizationServer);

var _AuthorizationServerError = require('../model/AuthorizationServerError');

var _AuthorizationServerError2 = _interopRequireDefault(_AuthorizationServerError);

var _ErrorResponse = require('../model/ErrorResponse');

var _ErrorResponse2 = _interopRequireDefault(_ErrorResponse);

var _Login = require('../model/Login');

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* Authdb service.
* @module /api/AuthdbApi
* @version 1.0.0
*/
var AuthdbApi = function () {

  /**
  * Constructs a new AuthdbApi. 
  * @alias module:/api/AuthdbApi
  * @class
  * @param {module:/ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:/ApiClient#instance} if unspecified.
  */
  function AuthdbApi(apiClient) {
    _classCallCheck(this, AuthdbApi);

    this.apiClient = apiClient || _ApiClient2.default.instance;
  }

  /**
   * Callback function to receive the result of the loginChangePasswordPost operation.
   * @callback module:/api/AuthdbApi~loginChangePasswordPostCallback
   * @param {String} error Error message, if any.
   * @param data This operation does not return a value.
   * @param {String} response The complete HTTP response.
   */

  /**
   * change the user password with accesstoken
   * By passing the accesstoken and the new password, the user can re-impost his password. 
   * @param {String} authorization use to pass the refresh token obtained from a login
   * @param {String} oldpassword The last password of the user.
   * @param {String} newpassword The new password to insert into the DB.
   * @param {module:/api/AuthdbApi~loginChangePasswordPostCallback} callback The callback function, accepting three arguments: error, data, response
   */


  _createClass(AuthdbApi, [{
    key: 'loginChangePasswordPost',
    value: function loginChangePasswordPost(authorization, oldpassword, newpassword, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling loginChangePasswordPost");
      }
      // verify the required parameter 'oldpassword' is set
      if (oldpassword === undefined || oldpassword === null) {
        throw new Error("Missing the required parameter 'oldpassword' when calling loginChangePasswordPost");
      }
      // verify the required parameter 'newpassword' is set
      if (newpassword === undefined || newpassword === null) {
        throw new Error("Missing the required parameter 'newpassword' when calling loginChangePasswordPost");
      }

      var pathParams = {};
      var queryParams = {
        'oldpassword': oldpassword,
        'newpassword': newpassword
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login/ChangePassword', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginChangePasswordWithLinkPost operation.
     * @callback module:/api/AuthdbApi~loginChangePasswordWithLinkPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * change the user password with link
     * By passing the parameters, the user can re-impost his password through the parameters contained in the link preious generated by the method getEmailChangePassword. 
     * @param {String} authorization The token sended by the previous method.
     * @param {String} useremail The useremail password from the account to change the password.
     * @param {String} newpassword The new password to insert into the DB
     * @param {module:/api/AuthdbApi~loginChangePasswordWithLinkPostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'loginChangePasswordWithLinkPost',
    value: function loginChangePasswordWithLinkPost(authorization, useremail, newpassword, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling loginChangePasswordWithLinkPost");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling loginChangePasswordWithLinkPost");
      }
      // verify the required parameter 'newpassword' is set
      if (newpassword === undefined || newpassword === null) {
        throw new Error("Missing the required parameter 'newpassword' when calling loginChangePasswordWithLinkPost");
      }

      var pathParams = {};
      var queryParams = {
        'useremail': useremail,
        'newpassword': newpassword
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login/ChangePasswordWithLink', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginGet operation.
     * @callback module:/api/AuthdbApi~loginGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * login into the server
     * This method respect the **OAuth2.0 Standard** By passing a valid username and a password, you can retrieve the access token and the refresh token. 
     * @param {String} grantType pass the type of the request, for this method it is REQUIRED \"password\"
     * @param {Object} opts Optional parameters
     * @param {String} opts.authorization add user and password in a string like \"Basic base64([user]:[password])\"
     * @param {module:/api/AuthdbApi~loginGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'loginGet',
    value: function loginGet(grantType, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'grantType' is set
      if (grantType === undefined || grantType === null) {
        throw new Error("Missing the required parameter 'grantType' when calling loginGet");
      }

      var pathParams = {};
      var queryParams = {
        'grant_type': grantType
      };
      var headerParams = {
        'authorization': opts['authorization']
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/login', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginGetEmailChangePasswordGet operation.
     * @callback module:/api/AuthdbApi~loginGetEmailChangePasswordGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generate an email to send to the email associated with user.
     * By passing the useremail, the user can re-impost his password. 
     * @param {String} useremail User email to send a link to re-impost the password.
     * @param {module:/api/AuthdbApi~loginGetEmailChangePasswordGetCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'loginGetEmailChangePasswordGet',
    value: function loginGetEmailChangePasswordGet(useremail, callback) {
      var postBody = null;
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling loginGetEmailChangePasswordGet");
      }

      var pathParams = {};
      var queryParams = {
        'useremail': useremail
      };
      var headerParams = {};
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login/getEmailChangePassword', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginPost operation.
     * @callback module:/api/AuthdbApi~loginPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add a new User
     * By passing all the information needed to modify a user, you can modify an existing user in the Dabase. 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} useremail use to pass the useremail of who you are trying to chage the information
     * @param {module:model/Login} body User object to add in the DB, instead of the old one.
     * @param {module:/api/AuthdbApi~loginPostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'loginPost',
    value: function loginPost(authorization, useremail, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling loginPost");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling loginPost");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling loginPost");
      }

      var pathParams = {};
      var queryParams = {
        'useremail': useremail
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginRefreshAtokenGet operation.
     * @callback module:/api/AuthdbApi~loginRefreshAtokenGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * retrieve a new access token
     * This method respect the **OAuth2.0 Standard** By passing a valid refreshtoken, you can retrieve a new refreshed access token. 
     * @param {String} grantType pass the type of the request, for this method it is REQUIRED \"refresh_token\"
     * @param {String} refreshToken pass the refreshtoken
     * @param {Object} opts Optional parameters
     * @param {String} opts.scope pass the scope of the access request
     * @param {module:/api/AuthdbApi~loginRefreshAtokenGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'loginRefreshAtokenGet',
    value: function loginRefreshAtokenGet(grantType, refreshToken, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'grantType' is set
      if (grantType === undefined || grantType === null) {
        throw new Error("Missing the required parameter 'grantType' when calling loginRefreshAtokenGet");
      }
      // verify the required parameter 'refreshToken' is set
      if (refreshToken === undefined || refreshToken === null) {
        throw new Error("Missing the required parameter 'refreshToken' when calling loginRefreshAtokenGet");
      }

      var pathParams = {};
      var queryParams = {
        'grant_type': grantType,
        'refresh_token': refreshToken,
        'scope': opts['scope']
      };
      var headerParams = {};
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/login/refreshAtoken', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginUseremailDelete operation.
     * @callback module:/api/AuthdbApi~loginUseremailDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete a user
     * By passing all the information needed to delete an existing user, you can delete the user in the database. 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} useremail use to pass the useremail of who you are trying to get the information
     * @param {module:/api/AuthdbApi~loginUseremailDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'loginUseremailDelete',
    value: function loginUseremailDelete(authorization, useremail, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling loginUseremailDelete");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling loginUseremailDelete");
      }

      var pathParams = {
        'useremail': useremail
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login/{useremail}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the loginUseremailPut operation.
     * @callback module:/api/AuthdbApi~loginUseremailPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * modify  user
     * By passing all the information needed to create a new user, you can adding in the database a new user and allow him to login. 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} useremail use to pass the useremail of who you are trying to get the information
     * @param {module:model/Login} body User object to add in the DB
     * @param {module:/api/AuthdbApi~loginUseremailPutCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'loginUseremailPut',
    value: function loginUseremailPut(authorization, useremail, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling loginUseremailPut");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling loginUseremailPut");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling loginUseremailPut");
      }

      var pathParams = {
        'useremail': useremail
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/login/{useremail}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return AuthdbApi;
}();

exports.default = AuthdbApi;
//# sourceMappingURL=AuthdbApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/renderfarmapi/lib/lib-commonjs/api/AuthdbApi.js
// module id = 1447
// module chunks = 142